export default "__VITE_ASSET__BTjrqb0___"